/**
 * Hide scroll fade
 */
class HideScrollFade extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    this.target = document.querySelector(this.getAttribute('target'));
    this.target.addEventListener('scroll', () => this.target.classList.add('hide-fade'), { once: true });
  }
}
customElements.define('hide-scroll-fade', HideScrollFade);
